import { createClient } from "@supabase/supabase-js";

// `supabase start` prints the URL and publishable key; copy them into .env (see .env.example).
const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined;

export const authConfigured = Boolean(url && key);
export const supabase = authConfigured ? createClient(url!, key!) : null;
